import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Button from '@/components/Button/Button';
import { useFormatText } from '@/hooks/useFormatText';

interface ICancelSubscriptionCardProps {
  onCancelClick: () => void;
  canCancel: boolean;
  isCancelling?: boolean;
}

const CancelSubscriptionCard = ({
  onCancelClick,
  canCancel,
  isCancelling = false,
}: ICancelSubscriptionCardProps) => {
  const { formatText } = useFormatText();

  return (
    <div className="mt-8 border border-neutral-light-200 rounded-xl">
      <div className="p-6 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex flex-col gap-3">
          <h3 className="text-base font-semibold text-neutral-primary">
            {formatText('settings.subscription.cancel-subscription')}
          </h3>
          <p className="text-sm text-neutral-secondary">
            <FormattedMessage
              id="settings.subscription.cancel-policy"
              values={{
                link: (
                  <Link
                    to={import.meta.env.VITE_APP_CANCELLATION_POLICY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    {formatText('settings.subscription.cancel-policy-link')}
                  </Link>
                ),
              }}
            />
          </p>
        </div>
        <Button
          label={formatText('settings.subscription.cancel-subscription')}
          variant="outline"
          desructive
          className={clsx(
            'border!',
            canCancel ? 'border-error-default!' : 'border-neutral-light-200!'
          )}
          onClick={onCancelClick}
          loading={isCancelling}
          disabled={!canCancel}
        />
      </div>
    </div>
  );
};

export default CancelSubscriptionCard;
